"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  bootstrap3: require('./bootstrap3')(),
  bootstrap4: require('./bootstrap4')(),
  bulma: require('./bulma')(),
  tailwind: require('./tailwind')()
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/themes/themes.js
// module id = 266
// module chunks = 0